// components/DataField.tsx
import React from "react";

type DataFieldProps = {
  dataIndex: string;
  record: any;
  label?: string;
  render?: (value: any) => React.ReactNode;
  key: string;
};

export const DataField: React.FC<DataFieldProps> = ({ dataIndex, record, label, render, key }) => {
  const value = dataIndex
    .split(".") // permite pegar nested ex: "pagamentos.0.domicilioPagamento.ispb"
    .reduce((obj, key) => (obj ? obj[key] : undefined), record);

  return (
    <p>
      {label && <strong>{label}:</strong>} {render ? render(value) : value || "-"}
    </p>
  );
};
